import { ReactElement, useEffect, useRef, useState } from 'react'
import { CSSProperties } from 'styled-components'
import { BugsnagClient } from 'utils/bugsnagClient'

export const MapComponent = ({
  address,
  style,
}: {
  address: string
  style?: CSSProperties
}): ReactElement => {
  const [status, setStatus] = useState<google.maps.GeocoderStatus>()
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (typeof window === 'undefined' || !ref.current) return
    const geocoder = new google.maps.Geocoder()
    const map = new window.google.maps.Map(ref.current, {
      zoom: 18,
    })

    let marker: google.maps.Marker
    geocoder.geocode({ address: address }, (results, status) => {
      setStatus(status)
      if (status !== google.maps.GeocoderStatus.OK || !results) {
        BugsnagClient.notify(new Error(status))
        return
      }
      const geocoderResult = results[0]
      map.setCenter(geocoderResult.geometry.location)

      marker = new google.maps.Marker({
        map: map,
        position: geocoderResult.geometry.location,
      })
    })

    return () => {
      map && map.unbindAll()
      marker && marker.unbindAll()
    }
  })

  // 不正な住所などでマップを読み込めない場合は何も表示しない
  if (status && status !== google.maps.GeocoderStatus.OK) return <></>

  return <div ref={ref} id="map" style={{ ...style }} />
}
